import * as React from 'react';
import DashboardOutlined from './dashboard-outlined';
import DashboardFilled from './dashboard-filled';
import type { IconCombinedProps } from './types';
const DashboardCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <DashboardFilled ref={ref} {...rest} />;
  }
  return <DashboardOutlined ref={ref} {...rest} />;
});
export default DashboardCombined;